import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nav", "overlay", "toggle"]
  
  connect() {
    // Close navigation when clicking outside
    if (this.hasOverlayTarget) this.overlayTarget.addEventListener('click', () => this.close())
    
    // Handle resize events
    window.addEventListener('resize', () => {
      if (window.innerWidth > 992) {
        this.close()
      }
    })
  }
  
  toggle() {
    if (this.hasNavTarget) {
      const isOpen = this.navTarget.classList.contains('active')
      isOpen ? this.close() : this.open()
    } else {
      console.log('No nav target foundff!')
    }
  }
  
  open() {
    if (this.hasNavTarget) this.navTarget.classList.add('active')
    if (this.hasOverlayTarget) this.overlayTarget.classList.add('active')
    if (this.hasToggleTarget) this.toggleTarget.classList.add('active')

    // Prevent body scroll when nav is open
    document.body.classList.add('nav-open')
  }
  
  close() {
    if (this.hasNavTarget) this.navTarget.classList.remove('active')
    if (this.hasOverlayTarget) this.overlayTarget.classList.remove('active')
    if (this.hasToggleTarget) this.toggleTarget.classList.remove('active')

    // Re-enable body scroll
    document.body.classList.remove('nav-open')
  }
  
  // Close nav when a link inside is clicked
  closeOnNavigate(event) {
    // Only close on mobile
    if (window.innerWidth <= 992) this.close()
  }
}